import React, { Component } from 'react'

export default class SearchPost extends Component {
  constructor () {
    super()
    this.state = {
      search: ''
    }
  }

  onClickSearchField (e) {
    e.preventDefault()
    let newState = this.state.search

    if (newState === 'open') {
      newState = ''
    } else {
      newState = 'open'
    }
    this.setState({
      search: newState
    })
  }

  render() {
    const classSearch = `search ${this.state.search}`
    return (
      <div className={classSearch}>
        <a href="" onClick={this.onClickSearchField.bind(this)}>
          <i className="fa fa-search"></i>
          <i className="fa fa-times"></i>
        </a>
        <div className="field">
          <form className="clear">
            <button type="submit"><i className="fa fa-search"></i></button>
            <input type="text" />
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/search-post.js